import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/ui/Button/Button';
import ScreenshotSupport from 'components/shared/ScreenshotSupport';
import MaximizeModal from 'components/shared/MaximizeModal';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import useDraggableModal from 'hooks/useDraggableModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import RulesContent from './RulesContent';

interface RulesModalProps {
  onClose: () => void;
  flightId: string;
  tokenKey?: string;
  searchToken?: string;
}

const RulesModal: FC<RulesModalProps> = ({ onClose, flightId, tokenKey, searchToken }) => {
  const [t] = useTranslation();
  const { modalRef, modalStyle, dragHandleProps, isDragging } = useDraggableModal(true);
  const modalOverlayRef = useRef<HTMLDivElement>(null);

  return (
    <div
      className="modal-overlay modal-overlay-top modal-maximizable"
      ref={modalOverlayRef}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div ref={modalRef} className={'modal modal-sm active'} style={modalStyle}>
        <div
          className={'modal-title draggable-modal-handle' + (isDragging ? ' dragging' : '')}
          {...dragHandleProps}
        >
          <h5 className="title">{t('passenger.rule_display')}</h5>
          <div data-no-drag="true">
            <ScreenshotSupport />
            <MaximizeModal modalOverlayRef={modalOverlayRef} />
            <FontAwesomeIcon icon={faTimes as any} onClick={() => onClose()} />
          </div>
        </div>
        <div className="modal-content text-sm flight-rules pt-10">
          <RulesContent flightId={flightId} tokenKey={tokenKey} searchToken={searchToken} />
        </div>
        <div className="modal-footer">
          <Button title={t('close')} className="btn btn-default" onClick={() => onClose()} />
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(RulesModal, 'RulesModal');
